import { Check } from 'lucide-react'
import { cn } from '@/lib/utils'

export function Checkbox({ checked, onChange, label, description, className }) {
  return (
    <button
      type="button"
      onClick={() => onChange?.(!checked)}
      className={cn(
        'group flex w-full items-start gap-3 rounded-xl px-4 py-3 text-left',
        'ring-1 ring-inset transition-all duration-150',
        checked
          ? 'bg-primary-50 ring-primary-300 shadow-soft'
          : 'bg-white ring-ink-200 hover:ring-ink-300 hover:bg-ink-50/40',
        className,
      )}
    >
      <span
        className={cn(
          'mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-md ring-1 transition-all',
          checked
            ? 'bg-primary-700 ring-primary-700 text-cream'
            : 'bg-white ring-ink-300 group-hover:ring-ink-400',
        )}
      >
        {checked && <Check className="h-3.5 w-3.5" strokeWidth={3} />}
      </span>
      <span className="flex flex-col">
        <span
          className={cn(
            'text-sm font-semibold',
            checked ? 'text-primary-900' : 'text-ink-800',
          )}
        >
          {label}
        </span>
        {description && (
          <span className="mt-0.5 text-xs text-ink-500">{description}</span>
        )}
      </span>
    </button>
  )
}
